class Cart {
    constructor(section) {
        this.section = section;
        this.uiElements = ['cart-drawer-title', 'cart-drawer-products', 'cart-drawer-total']
        this.uiElementsClasses = ['cart-drawer-count']
        this.cover = section.querySelector('#cart-drawer-cover');
    }

    init() {
        this.section.addEventListener('click', (e) => {
            const quantityElement = e.target.classList.contains('cart-update') ? e.target : e.target.closest('.cart-update')
            if(quantityElement) {
                const quantityDataJson = quantityElement.getAttribute('data-quantity-data');
                const quantityData = JSON.parse(quantityDataJson);
                this.quantityChange(quantityData);
            }
        });
    }

    quantityChange(data) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', data.url + '.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
          if(xhr.status === 422) {
            const message = JSON.parse(xhr.responseText).message;
            alert(message)
          } else if (xhr.status === 200) {
            this.updateCartUi();
          }
        };


        xhr.send(JSON.stringify({
            id: data.id,
            quantity: data.type == 'remove' ? data.quantity - 1 : data.quantity + 1
        }));
    }

    updateCover(add) {
        if(add) {
            this.cover.style.opacity = 0.7;
            this.cover.style.pointerEvents = 'all';
            return
        } 
        this.cover.style.opacity = 0;
        this.cover.style.pointerEvents = 'none';
    }

    updateCartUi() {
        this.updateCover(true);
        fetch(window.Shopify.routes.root)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            this.uiElements.forEach(element => {
                const cartElement = document.getElementById(element);
                const cart = html.querySelector('#' + element);
                if(cartElement && cart) {
                    cartElement.innerHTML = cart.innerHTML;
                }
            });

            for (let i = 0; i < this.uiElementsClasses.length; i++) {
                const element = this.uiElementsClasses[i];
                let foundElement = null;
                const cartElements = document.getElementsByClassName(element);

                if(cartElements) {
                    for (var j = 0; j < cartElements.length; j++) {
                        foundElement = foundElement ?? html.querySelector('.' + element)
                        cartElements[j].innerHTML = foundElement.innerHTML;
                    }
                }
            }

            this.updateCover(false);
        })
        .catch(e => {
          this.updateCover(false);
          alert('An unexepcted error occured. Please try again later.')
          console.error(e);
        });
    }
}

export default Cart;